const manifest = {
  plugin_id: 1313,
  identifier: 'webview_component',
  manifest_version: '0.0.7',
  dependency_name: '',
  name: 'Webview component',
  description:
    'A webview component plugin that allows you to render a webpage within iframe inside the screen of the application',
  type: 'ui_component',
  api: {},
  dependency_repository_url: [],
  author_name: 'Applicaster',
  author_email: 'zapp@applicaster.com',
  screen: false,
  react_native: true,
  ui_builder_support: true,
  whitelisted_account_ids: [],
  deprecated_since_zapp_sdk: '',
  unsupported_since_zapp_sdk: '',
  targets: ['web'],
  ui_frameworks: ['quickbrick'],
  platform: 'web',
  dependency_version: '1.0.0',
  min_zapp_sdk: '0.0.1',
  data: {
    fields: [
      { key: 'source', label: 'Source', type: 'text_input' },
      { key: 'type', label: 'Type', type: 'select' },
    ],
  },
  styles: {
    fields: [
      {
        key: 'webview_height_type',
        label: 'Webview height type',
        type: 'select',
        options: [
          {
            value: 'custom',
            text: 'Custom',
          },
          {
            value: 'screen_height',
            text: 'Screen height',
          },
        ],
        initial_value: 'custom',
      },
      {
        type: 'number_input',
        key: 'webview_height',
        label: 'Webview height',
        initial_value: 100,
        conditional_fields: [
          {
            key: 'styles/webview_height_type',
            condition_value: 'custom',
          },
        ],
      },
      {
        type: 'number_input',
        key: 'component_mobile_margin_top',
        label: 'Webview mobile margin top',
        initial_value: null,
      },
      {
        type: 'number_input',
        key: 'component_tablet_margin_top',
        label: 'Webview tablet margin top',
        initial_value: null,
      },
      {
        type: 'number_input',
        key: 'component_desktop_margin_top',
        label: 'Webview desktop margin top',
        initial_value: null,
      },
      {
        type: 'number_input',
        key: 'component_large_desktop_margin_top',
        label: 'Webview large desktop margin top',
        initial_value: null,
      },

      {
        type: 'number_input',
        key: 'component_mobile_margin_bottom',
        label: 'Webview mobile margin bottom',
        initial_value: null,
      },
      {
        type: 'number_input',
        key: 'component_tablet_margin_bottom',
        label: 'Webview tablet margin bottom',
        initial_value: null,
      },
      {
        type: 'number_input',
        key: 'component_desktop_margin_bottom',
        label: 'Webview desktop margin bottom',
        initial_value: null,
      },
      {
        type: 'number_input',
        key: 'component_large_desktop_margin_bottom',
        label: 'Webview large desktop margin bottom',
        initial_value: null,
      },

      {
        type: 'number_input',
        key: 'component_mobile_padding_bottom',
        label: 'Webview mobile padding bottom',
        initial_value: null,
      },
      {
        type: 'number_input',
        key: 'component_tablet_padding_bottom',
        label: 'Webview tablet padding bottom',
        initial_value: null,
      },
      {
        type: 'number_input',
        key: 'component_desktop_padding_bottom',
        label: 'Webview desktop padding bottom',
        initial_value: null,
      },
      {
        type: 'number_input',
        key: 'component_large_desktop_padding_bottom',
        label: 'Webview large desktop padding bottom',
        initial_value: null,
      },

      {
        type: 'number_input',
        key: 'component_mobile_padding_right',
        label: 'Webview mobile padding right',
        initial_value: null,
      },
      {
        type: 'number_input',
        key: 'component_tablet_padding_right',
        label: 'Webview tablet padding right',
        initial_value: null,
      },
      {
        type: 'number_input',
        key: 'component_desktop_padding_right',
        label: 'Webview desktop padding right',
        initial_value: null,
      },
      {
        type: 'number_input',
        key: 'component_large_desktop_padding_right',
        label: 'Webview large desktop padding right',
        initial_value: null,
      },

      {
        type: 'number_input',
        key: 'component_mobile_padding_top',
        label: 'Webview mobile padding top',
        initial_value: null,
      },
      {
        type: 'number_input',
        key: 'component_tablet_padding_top',
        label: 'Webview tablet padding top',
        initial_value: null,
      },
      {
        type: 'number_input',
        key: 'component_desktop_padding_top',
        label: 'Webview desktop padding top',
        initial_value: null,
      },
      {
        type: 'number_input',
        key: 'component_large_desktop_padding_top',
        label: 'Webview large desktop padding top',
        initial_value: null,
      },

      {
        type: 'number_input',
        key: 'component_mobile_padding_left',
        label: 'Webview mobile padding left',
        initial_value: null,
      },
      {
        type: 'number_input',
        key: 'component_tablet_padding_left',
        label: 'Webview tablet padding left',
        initial_value: null,
      },
      {
        type: 'number_input',
        key: 'component_desktop_padding_left',
        label: 'Webview desktop padding left',
        initial_value: null,
      },
      {
        type: 'number_input',
        key: 'component_large_desktop_padding_left',
        label: 'Webview large desktop padding left',
        initial_value: null,
      },
    ],
  },
  rules: {
    fields: [
      {
        group: true,
        label: 'Advanced configuration',
        folded: true,
        fields: [
          {
            key: 'clear_cache_on_reload',
            label: 'Clear cache on reload',
            type: 'switch',
            initial_value: false,
            label_tooltip:
              'Enable this option to clear the cache every time the screen is loaded. This can be useful when the content changes frequently and you want to make sure the latest version is always displayed. Please note this will disable caching for the entire screen.',
          },
        ],
      },
    ],
  },
  general: {
    fields: [
      {
        key: 'url',
        type: 'text_input',
        label: 'Webview source url',
        initial_value: null,
      },
      {
        key: 'webview_accessibility_title',
        label: 'Webview Accessibility Title',
        type: 'text_input',
        initial_value: null,
      },
    ],
  },
  characteristics: {
    group: false,
    appearance: ['group', 'screen'],
    disable_default_cell_style: true,
  },
} as const;

export default manifest;
